// extracted by mini-css-extract-plugin
export var chip = "_mg-0";
export var icon = "_mg-1";
export var remove = "_mg-2";
export var removeIcon = "_mg-3";